<template>
    <div ref="rtecontent" v-html="content" class="rtecontent"></div>
</template>
<script>
import {evaluatePlatform} from '../utils/helper';

export default {
    name: 'anchor-content',
    props: {
        content: {},
    },
    methods: {
        handleUrl(event) {
            event.preventDefault();
            const {currentTarget} = event;
            const externalLink = currentTarget.hash === '';
            if (externalLink) {
                // extern
                if (evaluatePlatform() === 'app' && currentTarget.target === '_blank') {
                    cordova.InAppBrowser.open(currentTarget.href, '_system');
                } else if (evaluatePlatform() === 'app') {
                    cordova.InAppBrowser.open(currentTarget.href, '_blank', 'location=yes');
                } else {
                    window.open(currentTarget.href, currentTarget.target ? currentTarget.target : '_self');
                }
            } else {
                // local
                const url = new URL(currentTarget.href);
                const to = url.hash.substr(1);
                if (window.location.hash !== url.hash) {
                    event.preventDefault();
                    this.$router.push(to);
                }
            }
            return true;

        },

        removeEventListeners() {
            if (!this.$refs.rtecontent) {
                return;
            }

            const anchors = this.$refs.rtecontent.querySelectorAll('a');
            anchors.forEach((anchor) => {
                anchor.removeEventListener('click', this.handleUrl);
            });
        },
        addEventListeners() {
            if (!this.$refs.rtecontent) {
                return;
            }

            const anchors = this.$refs.rtecontent.querySelectorAll('a');
            anchors.forEach((anchor) => {
                anchor.addEventListener('click', this.handleUrl);
            });
        },
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.removeEventListeners();
                this.addEventListeners();
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.addEventListeners();
        });
    },
    beforeDestroy() {
        this.removeEventListeners();
    },
};
</script>
